import moment from "moment";
import ChevronLeftIcon from "@ancon/wildcat-ui/shared/icons/chevron-left.svg";
import ChevronRightIcon from "@ancon/wildcat-ui/shared/icons/chevron-right.svg";
import clsx from "clsx";

import CalendarLegend from "./CalendarLegend";
import CalendarMonth from "./CalendarMonth";
import styles from "./Calendar.module.scss";
import Button from "../Button";
import HeadingText from "../HeadingText";

interface CalendarProps {
  highlightedDatesLabel?: string;
  showLegend?: boolean;
  className?: string;
}

export default function Calendar({
  highlightedDatesLabel,
  showLegend,
  className,
}: CalendarProps) {
  const isPrevMonthDisabled = true;

  return (
    <div className={clsx(styles.calendar, className)}>
      <div className={styles.calendarHeader}>
        <Button plain disabled={isPrevMonthDisabled}>
          <ChevronLeftIcon />
        </Button>
        <HeadingText as="h3">{moment().format("MMMM yyyy")}</HeadingText>
        <Button plain>
          <ChevronRightIcon />
        </Button>
      </div>
      <CalendarMonth />
      {showLegend && (
        <CalendarLegend highlightedDayLabel={highlightedDatesLabel} />
      )}
    </div>
  );
}
